import { GET_MENU, GET_MENU_SUCCESS } from "./actionTypes";

export const getMenu = () => {
  return {
    type: GET_MENU,
    payload: "",
  };
};

export const getMenuSuccess = (menu) => {
  return {
    type: GET_MENU_SUCCESS,
    payload: menu.data,
  };
};